import React, { useEffect, useState } from 'react';
import { Table, Button, Col, Row, Badge } from 'react-bootstrap';
import './TableAction.css';
import { fetchRefuseWords, addRefuseWords } from '../../services/LingvoSemanticAPI'
import { ModalWithRefuse } from '../RefuseWords/RefuseWords'

function TableAction(props) {
  
    const { data, action, action_name, title, selectedRowIndex, setSelectedRowIndex, selectedTopicOrSubtopicIndex } = props;
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [ignoreWords, setIgnoreWords] = useState([]);
    const [showRefuseWords, setShowRefuseWords] = useState(false);

    useEffect(() => {
        if (selectedRows.length === data.length && data.length > 0) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
        console.log(selectedRows);
    }, [selectedRows, data.length]);

    useEffect(() => {
         const getRefuseWords = async () => {
            try {
                const result = await fetchRefuseWords(selectedTopicOrSubtopicIndex);
                console.log(result.words);
                setIgnoreWords(result.words);
            } catch (error) {
                console.log(error);
            } finally {
            }
        }
        getRefuseWords();
    }, []);

    // Обработчик изменения общего чекбокса
    const handleSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        if (isChecked) {
            setSelectedRows(data.map((_, index) => index).sort((a, b) => b - a));
        } else {
            setSelectedRows([]);
        }
    };

    // Обработчик кнопки "Перенести всех"
    const handleMoveAll = async () => {

        await action(selectedRows.map(index => data[index]));

        // Сбросить выделение после выполнения
        setSelectedRows([]);
        setSelectAll(false);
    };

    // Обработчик изменения чекбокса строки
    const handleRowCheckboxChange = (index, e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedRows([...selectedRows, index].sort((a, b) => b - a));
        } else {
            setSelectedRows(selectedRows.filter(i => i !== index));
            setSelectAll(false);
        }
    };

    const handleShowIgnoreWords = (event) => {
        event.stopPropagation(); // Останавливаем всплытие
        console.log(ignoreWords);
        setShowRefuseWords(true);
        console.log('showRefuseWords', showRefuseWords);
    };

    const handleAddIgnoreWords = async (event) => {
        try {
            const result = await addRefuseWords(selectedTopicOrSubtopicIndex, selectedRows.map(index => data[index]));
            console.log(result.words);
            setIgnoreWords([...ignoreWords, ...result.words]);
        } catch (error) {
            console.log(error);
        } finally {
            // setSelectedRows([]);
            // setSelectAll(false);
        }
    };

    return (
        <>
            <Row>
                  <Col style={{ padding: '0 10px'}}>
                    <Button variant="primary" style={{margin: 'auto', width: '100%' }} 
                          disabled={selectedRows.length === 0}
                          onClick={handleAddIgnoreWords}>В игнор список
                          <Badge 
                            bg="light" 
                            text="dark"
                            style={{
                              marginLeft: '10px'
                            }}
                            onClick={handleShowIgnoreWords}
                          >
                            {ignoreWords.length}
                        </Badge>      
                    </Button>
                  </Col>
                  <Col  style={{ padding: '0 10px'}}>
                        <Button
                            variant="danger"
                            onClick={handleMoveAll}
                            disabled={selectedRows.length === 0}
                            style={{marginBottom: '5px', width: '100%' }}
                        >Перенести всех</Button>
                  </Col>
            </Row>
            <Table striped bordered hover className="combination-table">
                <thead onClick={() => setSelectedRowIndex(null)} style={{ cursor: 'default' }}>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAllChange}
                            />
                        </th>
                        <th>{ title }</th>
                        {/* <th>Действие</th> */}
                    </tr>
                </thead>
                <tbody>
                {data.map((row, index) => (
                    <tr 
                        key={ index }
                        className={index === selectedRowIndex ? 'table-active-row' : ''}
                        onClick={() => setSelectedRowIndex(index)}
                        style={{ cursor: 'pointer' }}
                    >
                    <td onClick={(e) => e.stopPropagation()}>
                        <input
                            type="checkbox"
                            checked={selectedRows.includes(index)}
                            onChange={(e) => handleRowCheckboxChange(index, e)}
                        />
                    </td>
                    <td>{ row }</td>
                    {/* <td style={{ whiteSpace: 'nowrap', width: '1%' }}>
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => action(index)}
                        >
                        {action_name}
                        </Button>
                    </td> */}
                    </tr>
                ))}
                </tbody>
            </Table>
            
            <ModalWithRefuse show={showRefuseWords} setShow={setShowRefuseWords} words={ ignoreWords }></ModalWithRefuse>

        </>

    );
}

export default TableAction;